import { AppState } from '../../types/store';
import { PageType } from '../../types/pageType';

export const getPageType = (state: AppState): PageType => state.pageType.pageType;
